import cta from '~/components/atoms/a-ctas/a-cta-v2.data'

export default {
  heading: 'Example Heading.',
  cta: [
    {
      ...cta,
      copy: 'View all',
      href: {
        url: '/events',
        cached_url: '/events',
      },
      type: 'secondary',
    },
  ],
  component: 'm-section-heading-v2',
}
